import { TIMES_ORDER_STATUS } from "componentsv2/kanban/constants";

function getMinutesElapsed(dateString) {
  const createdAt = new Date(dateString);
  createdAt.setHours(createdAt.getHours() - 5);
  const now = new Date();
  const diffMs = now - createdAt;

  return Math.max(0, Math.floor(diffMs / 1000 / 60));
}

function getOrderTimeStatus(dateString) {
  const minutes = getMinutesElapsed(dateString);

  return TIMES_ORDER_STATUS.find(
    (status) => minutes >= status.min && minutes <= status.max,
  );
}

function getElapsedTimeLabel(dateString) {
  const minutes = getMinutesElapsed(dateString);
  return `${minutes} Min`;
}

export { getOrderTimeStatus, getElapsedTimeLabel };
